const prefix = 'Invariant failed';

// Throw an error if the condition fails
export function invariant(condition: any, message?: string): asserts condition {
  if (condition) {
    return;
  }

  // Options:
  // 1. message provided: `${prefix}: ${provided}`
  // 2. message not provided: prefix
  const value: string = message ? `${prefix}: ${message}` : prefix;
  throw new Error(value);
}
